export const getKeyByValue = (object, value) =>
  Object.keys(object).find((key) => object[key] === value)

export const getScrollPosition = (ref) => {
  const NAV_BAR_HEIGHT = 57,
    PADDING = 100
  let top = ref.current.getBoundingClientRect().top
  return top + window.pageYOffset - NAV_BAR_HEIGHT - PADDING
}
